import * as React from "react";
import { Divider, Flex, FlexItem, Grid, Skeleton, Segment, Card, Box } from "@fluentui/react-northstar";
import "./loader.scss";
import "./loaderInfinite.scss";
import "./loaderPainel.scss";
import '../../components/settings/settings.scss';

const _ = require('lodash');

export const Loader = (): JSX.Element => {
    return (
        <div className="main-component">
            <div className={"form-container"}>
                <Skeleton className="skeleton" animation="pulse">
                    <Flex gap="gap.large" space="between">
                        <FlexItem size="size.quarter">
                            <Segment styles={{ boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" }}>
                                <Box
                                    styles={{
                                        display: "grid",
                                        gridGap: ".5rem",
                                        gridTemplate:
                                            "repeat(auto-fill, 2rem) / repeat(auto-fill, minmax(100%, 1fr))",
                                        gridAutoFlow: "dense",
                                        gridAutoRows: "15rem 2rem",
                                        padding: ".5rem",
                                        minWidth: "20rem",
                                        "@media (max-width: 986px)": {
                                            gridTemplate:
                                                "repeat(auto-fill, 25rem) / repeat(auto-fill, minmax(15.75rem, 1fr))",
                                        },
                                    }}
                                >
                                    <Card.Header>
                                        <Flex gap="gap.small" space="between" style={{ minHeight: "2rem" }}>
                                            <Flex gap="gap.small" column>
                                                <Skeleton.Line width="150px" />
                                            </Flex>
                                        </Flex>
                                    </Card.Header>
                                    <Card.Body
                                        style={{
                                            marginBottom: "0.75rem",
                                            height: "100%",
                                            overflow: "hidden",
                                        }}
                                        fitted
                                    >
                                        <Flex gap="gap.large"
                                            styles={{
                                                height: "90%",
                                                display: "flex",
                                            }}
                                            column
                                        >
                                            <Skeleton.Shape width="100%" height="100%" />
                                        </Flex>
                                    </Card.Body>
                                </Box>
                            </Segment>
                        </FlexItem>

                        <FlexItem size="size.quarter">
                            <Segment styles={{ boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" }}>
                                <Box
                                    styles={{
                                        display: "grid",
                                        gridGap: ".5rem",
                                        gridTemplate:
                                            "repeat(auto-fill, 2rem) / repeat(auto-fill, minmax(100%, 1fr))",
                                        gridAutoFlow: "dense",
                                        gridAutoRows: "15rem 2rem",
                                        padding: ".5rem",
                                        minWidth: "20rem",
                                        "@media (max-width: 986px)": {
                                            gridTemplate:
                                                "repeat(auto-fill, 25rem) / repeat(auto-fill, minmax(15.75rem, 1fr))",
                                        },
                                    }}
                                >
                                    <Card.Header>
                                        <Flex gap="gap.small" space="between" style={{ minHeight: "2rem" }}>
                                            <Flex gap="gap.small" column>
                                                <Skeleton.Line width="150px" />
                                            </Flex>
                                        </Flex>
                                    </Card.Header>
                                    <Card.Body
                                        style={{
                                            marginBottom: "0.75rem",
                                            height: "100%",
                                            overflow: "hidden",
                                        }}
                                        fitted
                                    >
                                        <Flex
                                            styles={{
                                                height: "90%",
                                                display: "flex",
                                            }}
                                            column
                                        >
                                            <Skeleton.Shape width="100%" height="100%" />
                                        </Flex>
                                    </Card.Body>
                                </Box>
                            </Segment>
                        </FlexItem>

                        <FlexItem size="size.half">
                            <Segment styles={{ boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" }}>
                                <Box
                                    styles={{
                                        display: "grid",
                                        gridGap: ".5rem",
                                        gridTemplate:
                                            "repeat(auto-fill, 2rem) / repeat(auto-fill, minmax(100%, 1fr))",
                                        gridAutoFlow: "dense",
                                        gridAutoRows: "15rem 2rem",
                                        padding: ".5rem",
                                        minWidth: "20rem",
                                        "@media (max-width: 986px)": {
                                            gridTemplate:
                                                "repeat(auto-fill, 25rem) / repeat(auto-fill, minmax(15.75rem, 1fr))",
                                        },
                                    }}
                                >
                                    <Card.Header>
                                        <Flex gap="gap.small" space="between" style={{ minHeight: "2rem" }}>
                                            <Flex gap="gap.small" column>
                                                <Skeleton.Line width="150px" />
                                            </Flex>
                                        </Flex>
                                    </Card.Header>
                                    <Card.Body
                                        style={{
                                            marginBottom: "0.75rem",
                                            height: "100%",
                                            overflow: "hidden",
                                        }}
                                        fitted
                                    >
                                        <Flex
                                            styles={{
                                                height: "90%",
                                                display: "flex",
                                            }}
                                            column
                                        >
                                            <Skeleton.Shape width="100%" height="100%" />
                                        </Flex>
                                    </Card.Body>
                                </Box>
                            </Segment>
                        </FlexItem>
                    </Flex>

                    <div style={{ boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" }}>
                        <Flex
                            space="between"
                            className="toolbar-serventias"
                            styles={{
                                position: "sticky",
                                top: 0,
                                padding: "1.25rem 1.25rem 1.25rem 0",
                                margin: "1.25rem 0",
                                zIndex: 999,
                            }}>
                            <Flex gap="gap.small">
                                <FlexItem>
                                    <Skeleton.Input styles={{ width: "18rem" }} />
                                </FlexItem>

                                <FlexItem>
                                    <Skeleton.Input styles={{ width: "20rem" }} />
                                </FlexItem>
                                <FlexItem>
                                    <Skeleton.Input styles={{ width: "20rem" }} />
                                </FlexItem>
                                <FlexItem>
                                    <Skeleton.Input styles={{ width: "20rem" }} />
                                </FlexItem>
                            </Flex>
                            <Flex gap="gap.small" vAlign="end">
                                <FlexItem>
                                    <Skeleton.Input styles={{ width: "20rem" }} />
                                </FlexItem>
                                <FlexItem>
                                    <Skeleton.Input styles={{ width: "16rem" }} />
                                </FlexItem>
                                <FlexItem>
                                    <Skeleton.Input styles={{ width: "12rem" }} />
                                </FlexItem>
                            </Flex>
                        </Flex>

                        <div className="form-content-container" >
                            <Grid columns="1fr 0.6fr 0.4fr 0.3fr">
                                <Flex gap="gap.small" className="header">
                                    <FlexItem>
                                        <Skeleton.Line width="40%" />
                                    </FlexItem>
                                    <FlexItem>
                                        <Skeleton.Line width="10%" />
                                    </FlexItem>
                                    <FlexItem>
                                        <Skeleton.Line width="10%" />
                                    </FlexItem>
                                </Flex>

                                <Flex gap="gap.small" className="header">
                                    <FlexItem>
                                        <Skeleton.Line width="40%" />
                                    </FlexItem>
                                    <FlexItem>
                                        <Skeleton.Line width="10%" />
                                    </FlexItem>
                                </Flex>

                                <Flex gap="gap.small" className="header">
                                    <FlexItem>
                                        <Skeleton.Line width="40%" />
                                    </FlexItem>
                                    <FlexItem>
                                        <Skeleton.Line width="10%" />
                                    </FlexItem>
                                </Flex>

                                <Flex gap="gap.small" className="header">
                                    <FlexItem>
                                        <Skeleton.Line width="40%" />
                                    </FlexItem>
                                    <FlexItem>
                                        <Skeleton.Line width="10%" />
                                    </FlexItem>
                                </Flex>

                                {_.times(5, (index: number) => (
                                    <React.Fragment key={index}>
                                        <Flex gap="gap.large" styles={{ padding: "2rem 1rem 2rem 0" }}>
                                            <Skeleton.Line width="100%" />
                                        </Flex>

                                        <Flex gap="gap.large" styles={{ padding: "2rem 1rem 2rem 0" }}>
                                            <Skeleton.Line width="100%" />
                                        </Flex>

                                        <Flex gap="gap.large" styles={{ padding: "2rem 1rem 2rem 0" }}>
                                            <Skeleton.Line width="100%" />
                                        </Flex>

                                        <Flex gap="gap.large" styles={{ padding: "2rem 1rem 2rem 0" }}>
                                            <Skeleton.Line width="100%" />
                                        </Flex>

                                        <Flex gap="gap.large" styles={{ padding: "2rem 1rem 2rem 0" }}>
                                            <Skeleton.Line width="100%" />
                                        </Flex>
                                    </React.Fragment>
                                ))}

                            </Grid>
                        </div>
                    </div>
                </Skeleton>
            </div>
        </div>
    );
};

export const LoaderAgendamento = (): JSX.Element => {
    return (
        <Flex>
            <Skeleton animation="pulse">
                <div className="agendamento-tab">
                    <div className="formContainer">
                        <div className="formContentContainer">
                            <Flex className="agendamento" gap="gap.large" vAlign="center" column>
                                <Flex gap="gap.medium" column>
                                    <Flex gap="gap.small" column>
                                        <Skeleton.Line height="36px" />
                                    </Flex>
                                    <Flex gap="gap.small" column>
                                        <Skeleton.Line height="36px" />
                                    </Flex>
                                    <Flex gap="gap.small" column>
                                        <Skeleton.Line height="36px" />
                                    </Flex>
                                    <Flex gap="gap.small" column>
                                        <Skeleton.Line height="36px" />
                                    </Flex>
                                    <Flex gap="gap.small" column>
                                        <Skeleton.Line height="100px" />
                                    </Flex>
                                </Flex>
                            </Flex>

                            <div className="footerContainer">
                                <div className="buttonContainer">
                                    <Flex gap="gap.small">
                                        <Skeleton.Button />
                                        <Skeleton.Button />
                                    </Flex>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Skeleton>
        </Flex>
    );
};

interface ILoaderProps {
    visaoGeralUnidades?: boolean;
}

export const LoaderCharts = (props: ILoaderProps): JSX.Element => {
    if (props.visaoGeralUnidades) {
        return (
            <Skeleton className="skeleton" animation="pulse">
                <Flex gap="gap.smaller" space="between">
                    <Skeleton.Shape width="100%" height="15rem" />
                    <Skeleton.Shape width="90%" height="15rem" />
                </Flex>
            </Skeleton>
        );
    } else {
        return (
            <Skeleton className="skeleton" animation="pulse">
                <Flex gap="gap.smaller" column>
                    <Flex gap="gap.smaller" space="between" column>
                        <Skeleton.Shape width="100%" height="14.5rem" />
                    </Flex>

                    <Divider />

                    <Skeleton.Shape width="100%" height="1.8rem" />
                </Flex>
            </Skeleton>
        );
    }
};

export const LoaderConfigApp = (): JSX.Element => {
    return (
        <div className="taskModule">
            <Skeleton animation="pulse">
                <div className="formContainer">
                    <div className="formContentContainer" >
                        <div className="inputField">
                            <Flex gap="gap.small" column>
                                <Skeleton.Line width="150px" height="18px" className="label-field" />
                                <Skeleton.Line height="36px" />
                            </Flex>
                        </div>

                        <div className="inputField">
                            <Flex gap="gap.small" column>
                                <Skeleton.Line width="100px" height="18px" className="label-field" />
                                <Skeleton.Line height="36px" />
                            </Flex>
                        </div>

                        <div className="inputField">
                            <Flex space="between" gap="gap.small">
                                <FlexItem size="size.half">
                                    <div>
                                        <Skeleton.Line width="100px" height="18px" className="label-field" />
                                        <Skeleton.Line height="30px" />
                                    </div>
                                </FlexItem>

                                <FlexItem size="size.half">
                                    <div>
                                        <Skeleton.Line width="100px" height="18px" className="label-field" />
                                        <Skeleton.Line height="30px" />
                                    </div>
                                </FlexItem>
                            </Flex>
                        </div>

                        <div className="inputField">
                            <Flex gap="gap.small" column>
                                <Skeleton.Line width="100px" height="18px" className="label-field" />
                                <Skeleton.Line height="30px" />
                            </Flex>
                        </div>

                        <div className="inputField">
                            <Flex space="between" gap="gap.small">
                                <FlexItem size="size.half">
                                    <div>
                                        <Skeleton.Line width="100px" height="18px" className="label-field" />
                                        <Skeleton.Line height="36px" />
                                    </div>
                                </FlexItem>

                                <FlexItem size="size.half">
                                    <div>
                                        <div style={{ height: "38px" }} ></div>
                                        <Skeleton.Line height="36px" />
                                    </div>
                                </FlexItem>
                            </Flex>
                        </div>

                    </div>
                </div>

                <div className="footerContainer">
                    <div className="buttonContainer">
                        <Flex gap="gap.small">
                            <Skeleton.Button />
                            <Skeleton.Button />
                        </Flex>
                    </div>
                </div>
            </Skeleton>
        </div>
    );
};

export const LoaderFormBalcaoVirtual = (): JSX.Element => {
    return (
        <div className="taskModule">
            <Skeleton animation="pulse">
                <div className="formContainer">
                    <div className="formContentContainer" >

                        <Flex space="between" gap="gap.small" styles={{ padding: "1rem 3.2rem;" }}>
                            <FlexItem size="size.large">
                                <div>
                                    <Skeleton.Line width="150px" styles={{ margin: "0 0 10px 0; !important" }} />
                                    <Skeleton.Input fluid />
                                </div>
                            </FlexItem>

                            <FlexItem size="size.small">
                                <div>
                                    <Skeleton.Line width="50px" styles={{ margin: "0 0 10px 0; !important" }} />
                                    <Skeleton.Input fluid />
                                </div>
                            </FlexItem>
                        </Flex>

                        <Flex styles={{ padding: "1rem 3.2rem;" }} gap="gap.small" column>
                            <Skeleton.Line width="150px" />
                            <Skeleton.Line height="60px" />
                        </Flex>

                        <Flex styles={{ padding: "1rem 3.2rem;" }} gap="gap.small" column>
                            <Skeleton.Line width="150px" />
                            <Skeleton.Input fluid />
                        </Flex>

                        <Flex styles={{ padding: "1rem 3.2rem;" }} gap="gap.small" column>
                            <Skeleton.Line width="150px" />
                            <Skeleton.Input fluid />
                        </Flex>

                        <Flex styles={{ padding: "1rem 3.2rem;" }} gap="gap.small" column>
                            <Skeleton.Line width="150px" />
                            <Skeleton.Input fluid />
                        </Flex>

                        <Flex styles={{ padding: "1rem 3.2rem;" }} gap="gap.small" column>
                            <Skeleton.Line width="150px" />
                            <Skeleton.Input fluid />
                        </Flex>

                        <Flex space="between" gap="gap.small" styles={{ padding: "1rem 3.2rem;" }}>
                            <FlexItem size="size.half">
                                <div>
                                    <Skeleton.Line width="150px" styles={{ margin: "0 0 10px 0; !important" }} />
                                    <Skeleton.Input fluid />
                                </div>
                            </FlexItem>

                            <FlexItem size="size.half">
                                <div>
                                    <Skeleton.Line width="150px" styles={{ margin: "0 0 10px 0; !important" }} />
                                    <Skeleton.Input fluid />
                                </div>
                            </FlexItem>
                        </Flex>

                    </div>
                </div>

                <div className="footerContainer">
                    <div className="buttonContainer">
                        <Flex gap="gap.small">
                            <Skeleton.Button />
                            <Skeleton.Button />
                        </Flex>
                    </div>
                </div>
            </Skeleton>
        </div>
    );
};

export const LoaderHistoricoAtendimento = (): JSX.Element => {
    return (
        <div className="taskModuleDetalhes">
            <Skeleton animation="wave">
                <Grid styles={{
                    gridTemplateColumns: "0.5fr 0.5fr",
                    gridGap: "0rem 0.6rem",
                    padding: "0 0 1rem 0"
                }}>
                    {_.times(4, (index: number) => (
                        <React.Fragment key={index}>
                            <Flex gap="gap.large" styles={{ padding: "2rem 0" }}>
                                <Skeleton.Line width="100%" />
                            </Flex>

                            <Flex gap="gap.large" styles={{ padding: "2rem 0" }}>
                                <Skeleton.Line width="100%" />
                            </Flex>
                        </React.Fragment>
                    ))}
                </Grid>
            </Skeleton>
        </div>
    );
};

export const LoaderList = (): JSX.Element => {
    return (
        <div>
            <Skeleton animation="pulse">
                <Grid styles={{
                    gridTemplateColumns: "1fr 0.6fr 0.4fr 0.3fr",
                    gridGap: "0rem 0.6rem",
                    padding: "1.5rem",
                }}>
                    {_.times(6, (index: number) => (
                        <React.Fragment key={index}>
                            <Flex gap="gap.large" styles={{ padding: "2rem 0" }}>
                                <Skeleton.Line width="100%" />
                            </Flex>

                            <Flex gap="gap.large" styles={{ padding: "2rem 0" }}>
                                <Skeleton.Line width="100%" />
                            </Flex>

                            <Flex gap="gap.large" styles={{ padding: "2rem 0" }}>
                                <Skeleton.Line width="100%" />
                            </Flex>

                            <Flex gap="gap.large" styles={{ padding: "2rem 0" }}>
                                <Skeleton.Line width="100%" />
                            </Flex>
                        </React.Fragment>
                    ))}
                </Grid>
            </Skeleton>
        </div>
    );
};

export const LoaderPanel = (): JSX.Element => {
    return (
        <div className="main-component">
            <div className={"form-container"}>
                <Skeleton animation="pulse">
                    <Flex gap="gap.large" space="between">
                        <FlexItem size="size.quarter">
                            <Segment styles={{ boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" }}>
                                <Box
                                    className="visao-geral-atendimentos"
                                    styles={{
                                        display: "grid",
                                        gridGap: ".5rem",
                                        gridTemplate:
                                            "repeat(auto-fill, 2rem) / repeat(auto-fill, minmax(30rem, 1fr))",
                                        gridAutoFlow: "dense",
                                        gridAutoRows: "15rem 2rem",
                                        padding: ".5rem",
                                        minWidth: "20rem",
                                        "@media (max-width: 986px)": {
                                            gridTemplate:
                                                "repeat(auto-fill, 25rem) / repeat(auto-fill, minmax(15.75rem, 1fr))",
                                        },
                                    }}
                                >
                                    <Card.Header>
                                        <Flex gap="gap.small" space="between" style={{ minHeight: "2rem" }}>
                                            <Flex gap="gap.small" column>
                                                <Skeleton.Line width="150px" />
                                            </Flex>
                                        </Flex>
                                    </Card.Header>
                                    <Card.Body
                                        style={{
                                            marginBottom: "0.75rem",
                                            height: "100%",
                                            overflow: "hidden",
                                        }}
                                        fitted
                                    >
                                        <Flex gap="gap.large"
                                            styles={{
                                                height: "90%",
                                                display: "flex",
                                            }}
                                            column
                                        >
                                            <Skeleton.Shape width="100%" height="100%" />
                                        </Flex>
                                    </Card.Body>
                                </Box>
                            </Segment>
                        </FlexItem>

                        <FlexItem size="size.quarter">
                            <Segment styles={{ boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" }}>
                                <Box
                                    className="visao-geral-atendimentos"
                                    styles={{
                                        display: "grid",
                                        gridGap: ".5rem",
                                        gridTemplate:
                                            "repeat(auto-fill, 2rem) / repeat(auto-fill, minmax(35rem, 1fr))",
                                        gridAutoFlow: "dense",
                                        gridAutoRows: "15rem 2rem",
                                        padding: ".5rem",
                                        minWidth: "20rem",
                                        "@media (max-width: 986px)": {
                                            gridTemplate:
                                                "repeat(auto-fill, 25rem) / repeat(auto-fill, minmax(15.75rem, 1fr))",
                                        },
                                    }}
                                >
                                    <Card.Header>
                                        <Flex gap="gap.small" space="between" style={{ minHeight: "2rem" }}>
                                            <Flex gap="gap.small" column>
                                                <Skeleton.Line width="150px" />
                                            </Flex>
                                        </Flex>
                                    </Card.Header>
                                    <Card.Body
                                        style={{
                                            marginBottom: "0.75rem",
                                            height: "100%",
                                            overflow: "hidden",
                                        }}
                                        fitted
                                    >
                                        <Flex gap="gap.large"
                                            styles={{
                                                height: "90%",
                                                display: "flex",
                                            }}
                                            column
                                        >
                                            <Skeleton.Shape width="100%" height="100%" />
                                        </Flex>
                                    </Card.Body>
                                </Box>
                            </Segment>
                        </FlexItem>

                        <FlexItem size="size.half">
                            <Segment styles={{ boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" }}>
                                <Box
                                    styles={{
                                        display: "grid",
                                        gridGap: ".5rem",
                                        gridTemplate:
                                            "repeat(auto-fill, 2rem) / repeat(auto-fill, minmax(100%, 1fr))",
                                        gridAutoFlow: "dense",
                                        gridAutoRows: "15rem 2rem",
                                        padding: ".5rem",
                                        minWidth: "20rem",
                                        "@media (max-width: 986px)": {
                                            gridTemplate:
                                                "repeat(auto-fill, 25rem) / repeat(auto-fill, minmax(15.75rem, 1fr))",
                                        },
                                    }}
                                >
                                    <Card.Header>
                                        <Flex gap="gap.small" space="between" style={{ minHeight: "2rem" }}>
                                            <Flex gap="gap.small" column>
                                                <Skeleton.Line width="150px" />
                                            </Flex>
                                        </Flex>
                                    </Card.Header>
                                    <Card.Body
                                        style={{
                                            marginBottom: "0.75rem",
                                            height: "100%",
                                            overflow: "hidden",
                                        }}
                                        fitted
                                    >
                                        <Flex gap="gap.large"
                                            styles={{
                                                height: "90%",
                                                display: "flex",
                                            }}
                                            column
                                        >
                                            <Skeleton.Shape width="100%" height="100%" />
                                        </Flex>
                                    </Card.Body>
                                </Box>
                            </Segment>
                        </FlexItem>
                    </Flex>

                    <Flex
                        space="between"
                        styles={{
                            position: "sticky",
                            top: 0,
                            padding: "1.25rem 1.25rem 0.8rem 1.25rem",
                            margin: "1.25rem 0",
                            zIndex: 999,
                        }}>
                        <Flex
                            gap="gap.small"
                            styles={{
                                width: "100%"
                            }}
                        >
                            <FlexItem className={"tab-status-item"} >
                                <Skeleton.Input />
                            </FlexItem>

                            <FlexItem className={"tab-status-item"} >
                                <Skeleton.Input />
                            </FlexItem>

                            <FlexItem className={"tab-status-item"} >
                                <Skeleton.Input />
                            </FlexItem>

                            <FlexItem className={"tab-status-item"} >
                                <Skeleton.Input />
                            </FlexItem>

                        </Flex>
                    </Flex>

                    <Flex space="between" styles={{ boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" }}>
                        <Flex gap="gap.small"
                            space="between"
                            className="toolbar-acesso-rapido"
                            styles={{
                                position: "sticky",
                                top: 0,
                                margin: "1.5rem 0",
                                zIndex: 1,
                            }}>
                            <FlexItem className={"tab-status-item"} >
                                <Skeleton.Input styles={{ width: "10rem" }} />
                            </FlexItem>
                        </Flex>
                        <Flex gap="gap.medium" vAlign="center">
                            <FlexItem>
                                <Skeleton.Input styles={{ width: "20rem" }} />
                            </FlexItem>
                            <FlexItem>
                                <Skeleton.Input styles={{ width: "10rem" }} />
                            </FlexItem>
                        </Flex>
                    </Flex>

                    <div className="form-content-container" >
                        <Grid columns="1.1fr 0.5fr 0.5fr 0.3fr 0.2fr">
                            <Flex gap="gap.small" className="header">
                                <FlexItem>
                                    <Skeleton.Line width="40%" />
                                </FlexItem>
                                <FlexItem>
                                    <Skeleton.Line width="10%" />
                                </FlexItem>
                                <FlexItem>
                                    <Skeleton.Line width="10%" />
                                </FlexItem>
                            </Flex>

                            <Flex gap="gap.small" className="header">
                                <FlexItem>
                                    <Skeleton.Line width="40%" />
                                </FlexItem>
                                <FlexItem>
                                    <Skeleton.Line width="10%" />
                                </FlexItem>
                            </Flex>

                            <Flex gap="gap.small" className="header">
                                <FlexItem>
                                    <Skeleton.Line width="40%" />
                                </FlexItem>
                                <FlexItem>
                                    <Skeleton.Line width="10%" />
                                </FlexItem>
                            </Flex>

                            <Flex gap="gap.small" className="header">
                                <FlexItem>
                                    <Skeleton.Line width="40%" />
                                </FlexItem>
                                <FlexItem>
                                    <Skeleton.Line width="10%" />
                                </FlexItem>
                            </Flex>

                            <Flex gap="gap.small" className="header">
                                <FlexItem>
                                    <Skeleton.Line width="40%" />
                                </FlexItem>
                                <FlexItem>
                                    <Skeleton.Line width="10%" />
                                </FlexItem>
                            </Flex>

                            {_.times(5, (index: number) => (
                                <React.Fragment key={index}>
                                    <Flex gap="gap.large" styles={{ padding: "2rem 1rem 2rem 0" }}>
                                        <Skeleton.Line width="100%" />
                                    </Flex>

                                    <Flex gap="gap.large" styles={{ padding: "2rem 1rem 2rem 0" }}>
                                        <Skeleton.Line width="100%" />
                                    </Flex>

                                    <Flex gap="gap.large" styles={{ padding: "2rem 1rem 2rem 0" }}>
                                        <Skeleton.Line width="100%" />
                                    </Flex>

                                    <Flex gap="gap.large" styles={{ padding: "2rem 1rem 2rem 0" }}>
                                        <Skeleton.Line width="100%" />
                                    </Flex>

                                    <Flex gap="gap.large" styles={{ padding: "2rem 1rem 2rem 0" }}>
                                        <Skeleton.Line width="100%" />
                                    </Flex>
                                </React.Fragment>
                            ))}

                        </Grid>
                    </div>
                </Skeleton>
            </div>
        </div>
    );
};

export const LoaderPanelTeam = (): JSX.Element => {
    return (
        <div className="main-component">
            <div className={"form-container"}>
                <Skeleton animation="pulse">
                    <Flex gap="gap.large" space="between">
                        <FlexItem size="size.quarter">
                            <Segment styles={{ boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" }}>
                                <Box
                                    className="visao-geral-atendimentos"
                                    styles={{
                                        display: "grid",
                                        gridGap: ".5rem",
                                        gridTemplate:
                                            "repeat(auto-fill, 2rem) / repeat(auto-fill, minmax(35rem, 1fr))",
                                        gridAutoFlow: "dense",
                                        gridAutoRows: "15rem 2rem",
                                        padding: ".5rem",
                                        minWidth: "20rem",
                                        "@media (max-width: 986px)": {
                                            gridTemplate:
                                                "repeat(auto-fill, 25rem) / repeat(auto-fill, minmax(15.75rem, 1fr))",
                                        },
                                    }}
                                >
                                    <Card.Header>
                                        <Flex gap="gap.small" space="between" style={{ minHeight: "2rem" }}>
                                            <Flex gap="gap.small" column>
                                                <Skeleton.Line width="150px" />
                                            </Flex>
                                        </Flex>
                                    </Card.Header>
                                    <Card.Body
                                        style={{
                                            marginBottom: "0.75rem",
                                            height: "100%",
                                            overflow: "hidden",
                                        }}
                                        fitted
                                    >
                                        <Flex gap="gap.large"
                                            styles={{
                                                height: "90%",
                                                display: "flex",
                                            }}
                                            column
                                        >
                                            <Skeleton.Shape width="100%" height="100%" />
                                        </Flex>
                                    </Card.Body>
                                </Box>
                            </Segment>
                        </FlexItem>

                        <FlexItem size="size.half" styles={{ flexBasis: "100%" }}>
                            <Segment styles={{ boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" }}>
                                <Box
                                    styles={{
                                        display: "grid",
                                        gridGap: ".5rem",
                                        gridTemplate:
                                            "repeat(auto-fill, 2rem) / repeat(auto-fill, minmax(100%, 1fr))",
                                        gridAutoFlow: "dense",
                                        gridAutoRows: "15rem 2rem",
                                        padding: ".5rem",
                                        minWidth: "20rem",
                                        "@media (max-width: 986px)": {
                                            gridTemplate:
                                                "repeat(auto-fill, 25rem) / repeat(auto-fill, minmax(15.75rem, 1fr))",
                                        },
                                    }}
                                >
                                    <Card.Header>
                                        <Flex gap="gap.small" space="between" style={{ minHeight: "2rem" }}>
                                            <Flex gap="gap.small" column>
                                                <Skeleton.Line width="150px" />
                                            </Flex>
                                        </Flex>
                                    </Card.Header>
                                    <Card.Body
                                        style={{
                                            marginBottom: "0.75rem",
                                            height: "100%",
                                            overflow: "hidden",
                                        }}
                                        fitted
                                    >
                                        <Flex gap="gap.large"
                                            styles={{
                                                height: "90%",
                                                display: "flex",
                                            }}
                                            column
                                        >
                                            <Skeleton.Shape width="100%" height="100%" />
                                        </Flex>
                                    </Card.Body>
                                </Box>
                            </Segment>
                        </FlexItem>
                    </Flex>

                    <Flex
                        space="between"
                        styles={{
                            position: "sticky",
                            top: 0,
                            padding: "1.25rem 1.25rem 0.8rem 1.25rem",
                            margin: "1.25rem 0",
                            zIndex: 999,
                        }}>
                        <Flex
                            gap="gap.small"
                            styles={{
                                width: "100%"
                            }}
                        >
                            <FlexItem className={"tab-status-item"} >
                                <Skeleton.Input />
                            </FlexItem>

                            <FlexItem className={"tab-status-item"} >
                                <Skeleton.Input />
                            </FlexItem>

                            <FlexItem className={"tab-status-item"} >
                                <Skeleton.Input />
                            </FlexItem>

                            <FlexItem className={"tab-status-item"} >
                                <Skeleton.Input />
                            </FlexItem>

                        </Flex>
                    </Flex>

                    <Flex space="between" styles={{ boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" }}>
                        <Flex gap="gap.small"
                            space="between"
                            className="toolbar-acesso-rapido"
                            styles={{
                                position: "sticky",
                                top: 0,
                                margin: "1.5rem 0",
                                zIndex: 1,
                            }}>
                            <FlexItem className={"tab-status-item"} >
                                <Skeleton.Input styles={{ width: "10rem" }} />
                            </FlexItem>
                        </Flex>
                        <Flex gap="gap.medium" vAlign="center">
                            <FlexItem>
                                <Skeleton.Input styles={{ width: "20rem" }} />
                            </FlexItem>
                            <FlexItem>
                                <Skeleton.Input styles={{ width: "10rem" }} />
                            </FlexItem>
                        </Flex>
                    </Flex>

                    <div className="form-content-container" >
                        <Grid columns="1.1fr 0.5fr 0.5fr 0.3fr 0.2fr">
                            <Flex gap="gap.small" className="header">
                                <FlexItem>
                                    <Skeleton.Line width="40%" />
                                </FlexItem>
                                <FlexItem>
                                    <Skeleton.Line width="10%" />
                                </FlexItem>
                                <FlexItem>
                                    <Skeleton.Line width="10%" />
                                </FlexItem>
                            </Flex>

                            <Flex gap="gap.small" className="header">
                                <FlexItem>
                                    <Skeleton.Line width="40%" />
                                </FlexItem>
                                <FlexItem>
                                    <Skeleton.Line width="10%" />
                                </FlexItem>
                            </Flex>

                            <Flex gap="gap.small" className="header">
                                <FlexItem>
                                    <Skeleton.Line width="40%" />
                                </FlexItem>
                                <FlexItem>
                                    <Skeleton.Line width="10%" />
                                </FlexItem>
                            </Flex>

                            <Flex gap="gap.small" className="header">
                                <FlexItem>
                                    <Skeleton.Line width="40%" />
                                </FlexItem>
                                <FlexItem>
                                    <Skeleton.Line width="10%" />
                                </FlexItem>
                            </Flex>

                            <Flex gap="gap.small" className="header">
                                <FlexItem>
                                    <Skeleton.Line width="40%" />
                                </FlexItem>
                                <FlexItem>
                                    <Skeleton.Line width="10%" />
                                </FlexItem>
                            </Flex>

                            {_.times(5, (index: number) => (
                                <React.Fragment key={index}>
                                    <Flex gap="gap.large" styles={{ padding: "2rem 1rem 2rem 0" }}>
                                        <Skeleton.Line width="100%" />
                                    </Flex>

                                    <Flex gap="gap.large" styles={{ padding: "2rem 1rem 2rem 0" }}>
                                        <Skeleton.Line width="100%" />
                                    </Flex>

                                    <Flex gap="gap.large" styles={{ padding: "2rem 1rem 2rem 0" }}>
                                        <Skeleton.Line width="100%" />
                                    </Flex>

                                    <Flex gap="gap.large" styles={{ padding: "2rem 1rem 2rem 0" }}>
                                        <Skeleton.Line width="100%" />
                                    </Flex>

                                    <Flex gap="gap.large" styles={{ padding: "2rem 1rem 2rem 0" }}>
                                        <Skeleton.Line width="100%" />
                                    </Flex>
                                </React.Fragment>
                            ))}

                        </Grid>
                    </div>
                </Skeleton>
            </div>
        </div>
    );
};

export const LoaderVisaoGeralAtendimentos = (): JSX.Element => {
    return (
        <Skeleton className="skeleton" animation="pulse">
            <Flex gap="gap.smaller" column>
                <Flex gap="gap.smaller" space="between" column>
                    <Skeleton.Shape width="100%" height="14.5rem" />
                </Flex>

                <Divider />

                <Skeleton.Shape width="100%" height="1.8rem" />
            </Flex>
        </Skeleton>
    );
};

export const LoaderInfinite = (): JSX.Element => {
    return (
        <div className="stage">
            <div className="dot-flashing"></div>
        </div>
    );
};